module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "id_footer"
    }
  }, [_c('div', {
    staticClass: "ribbon"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer_text"
  }, [_vm._v("Copyright © Polstar Technologies, Inc. All rights reserved.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a69e1ff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/layout/Footer.vue
// module id = 105
// module chunks = 1